<template>
  <div @mouseenter="hover()" @mouseleave="hover()" class="hightlight-card">
    <img
      class="hightlight-card-img img-fluid"
      :src="image"
      alt=""
      srcset=""
    />
    <i v-show="isShown" class=" highlight-card-ico" :class="ico"></i>
    <span v-show="!isShown" class="hightlight-card-desc"> {{ desc }} </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // image: require('@/assets/image3.jpg'),
      hoverIco: require("@/assets/imgico.webp"),
      isShown: false,
    };
  },
  props: {
    type: String,
    image: String,
    desc: String,
  },
  methods: {
    hover() {
      this.isShown = !this.isShown;
    },
  },
  computed: {
    ico() {
      if (this.type == "video") {
        return "fas fa-video";
      } else {
        return "fas fa-image";
      }
    },
  },
};
</script>

<style src="./HighlightCard.css" scoped></style>
